import Image from '@tiptap/extension-image';
import { Plugin } from 'prosemirror-state';
import { isAllowedImageSrc } from '@/utils/imageUrlUtils';

// Email-safe image node: adds a real `width` attribute (Outlook ignores CSS
// width on <img>, so it needs the HTML attribute), disables the markdown
// `![alt](src)` input rule (it would insert an unvalidated image as the
// user types), and guards against pasted/dropped <img> tags carrying a
// disallowed src (http:, cid:, data:image/svg+xml, oversized base64, etc.).
export const EmailSafeImage = Image.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      width: {
        default: null,
        parseHTML: (el) => el.getAttribute('width'),
        renderHTML: (attrs) => (attrs.width ? { width: attrs.width } : {}),
      },
    };
  },

  addInputRules() {
    return [];
  },

  addProseMirrorPlugins() {
    return [
      new Plugin({
        appendTransaction(transactions, oldState, newState) {
          if (!transactions.some((transaction) => transaction.docChanged)) {
            return undefined;
          }

          const disallowedPositions: number[] = [];

          newState.doc.descendants((node, pos) => {
            if (node.type.name === 'image' && !isAllowedImageSrc(node.attrs.src)) {
              disallowedPositions.push(pos);
            }
            return true;
          });

          if (disallowedPositions.length === 0) {
            return undefined;
          }

          const tr = newState.tr;

          // Delete from the highest position to the lowest so earlier
          // deletions don't invalidate later positions.
          disallowedPositions
            .sort((a, b) => b - a)
            .forEach((pos) => {
              const node = tr.doc.nodeAt(pos);
              if (node) {
                tr.delete(pos, pos + node.nodeSize);
              }
            });

          return tr;
        },
      }),
    ];
  },
}).configure({
  inline: false,
  allowBase64: true,
  HTMLAttributes: {
    style: 'max-width:100%;height:auto;display:block;border:0',
  },
});

export default EmailSafeImage;
